import './provider-section.sass';
import { Container, Row, Col } from 'react-bootstrap';
import provider_pic from '../../assets/images/provider_pic.png';
import android_pic from '../../assets/images/android.png';
import ios_pic from '../../assets/images/ios.png';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const provider_android_href = 'https://play.google.com/';
const provider_ios_href = 'https://www.apple.com/pt/app-store/';

function Provider() {
  const { t } = useTranslation();

  return (
    <Container fluid className="container-provider">
      <Row>
        <Col>
          <img src={provider_pic} className="provider-pic" alt="provider-pic" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={6}>
          <h1>
            <Trans i18nKey="work_with_us" />
          </h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={4}>
          <p>
            <Trans i18nKey="join_nobel_team" />
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="image-row">
          <a
            href={provider_android_href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={android_pic} className="android-pic" alt="android-pic" />
          </a>
          <a href={provider_ios_href} target="_blank" rel="noopener noreferrer">
            <img src={ios_pic} className="ios-pic" alt="ios-pic" />
          </a>
        </Col>
      </Row>
    </Container>
  );
}

export { Provider };
